import { FaBroom, FaCheckCircle, FaExclamationTriangle, FaSearch, FaTools } from "react-icons/fa";

import colors from "assets/theme/base/colors";

const { primary, success, warning, error, info, light } = colors;

export const RESOURCE_STATES = {
  DIRTY: "Dirty",
  CLEAN: "Clean",
  INSPECTED: "Inspected",
  OUT_OF_SERVICE: "OutOfService",
  OUT_OF_ORDER: "OutOfOrder",
};

export const OCCUPANCY_STATES = {
  VACANT: "Vacant",
  RESERVED: "Reserved",
  RESERVED_LOCKED: "ReservedLocked",
  INTERNAL_USE: "InternalUse",
  OUT_OF_ORDER: "OutOfOrder",
};

export const RESOURCE_STATE_CONFIG = {
  [RESOURCE_STATES.DIRTY]: {
    value: RESOURCE_STATES.DIRTY,
    label: "Dirty",
    filterLabel: "Dirty",
    color: "#ef4444",
    icon: FaExclamationTriangle,
    description: "Room requires cleaning",
  },

  [RESOURCE_STATES.CLEAN]: {
    value: RESOURCE_STATES.CLEAN,
    label: "Clean",
    filterLabel: "Clean",
    color: "#16ac9b",
    icon: FaBroom,
    description: "Room cleaning has been completed",
  },

  [RESOURCE_STATES.INSPECTED]: {
    value: RESOURCE_STATES.INSPECTED,
    label: "Inspected",
    filterLabel: "Inspected",
    color: "#1cac51",
    icon: FaCheckCircle,
    description: "Room has passed housekeeping inspection",
  },

  [RESOURCE_STATES.OUT_OF_SERVICE]: {
    value: RESOURCE_STATES.OUT_OF_SERVICE,
    label: "Out of Service",
    filterLabel: "Out of Service",
    color: "#dd8f08",
    icon: FaTools,
    description: "Room is temporarily unavailable",
  },

  [RESOURCE_STATES.OUT_OF_ORDER]: {
    value: RESOURCE_STATES.OUT_OF_ORDER,
    label: "Out of Order",
    filterLabel: "Out of Order",
    color: "#ef4444",
    icon: FaExclamationTriangle,
    description: "Room cannot currently be used",
  },
};

export const OCCUPANCY_STATE_CONFIG = {
  [OCCUPANCY_STATES.VACANT]: {
    value: OCCUPANCY_STATES.VACANT,
    label: "Vacant",
    color: "#22c55e",
  },

  [OCCUPANCY_STATES.RESERVED]: {
    value: OCCUPANCY_STATES.RESERVED,
    label: "Reserved",
    color: "#3b82f6",
  },

  [OCCUPANCY_STATES.RESERVED_LOCKED]: {
    value: OCCUPANCY_STATES.RESERVED_LOCKED,
    label: "Reserved Locked",
    color: "#8b5cf6",
  },

  [OCCUPANCY_STATES.INTERNAL_USE]: {
    value: OCCUPANCY_STATES.INTERNAL_USE,
    label: "Internal Use",
    color: "#64748b",
  },

  [OCCUPANCY_STATES.OUT_OF_ORDER]: {
    value: OCCUPANCY_STATES.OUT_OF_ORDER,
    label: "Out of Order",
    color: "#ef4444",
  },
};

export const RESOURCE_STATE_OPTIONS = Object.values(RESOURCE_STATE_CONFIG);

export const OCCUPANCY_STATE_OPTIONS = Object.values(OCCUPANCY_STATE_CONFIG);

export const HOUSEKEEPING_STATUS_FILTERS = [
  {
    label: "All",
    value: undefined,
  },
  ...RESOURCE_STATE_OPTIONS.map((status) => ({
    label: status.filterLabel,
    value: status.value,
  })),
];

export const getResourceStateConfig = (state) =>
  RESOURCE_STATE_CONFIG[state] || {
    value: state || "",
    label: state || "Unknown",
    filterLabel: state || "Unknown",
    color: "#64748b",
    icon: FaExclamationTriangle,
    description: "Unknown room housekeeping state",
  };

export const getOccupancyStateConfig = (state) =>
  OCCUPANCY_STATE_CONFIG[state] || {
    value: state || "",
    label: state || "Unknown",
    color: "#64748b",
  };
